import { Box, Typography } from "@drone-js/core";
import { Map as GoogleMaps, Marker } from "@vis.gl/react-google-maps";
import { VStack } from "apps/commons/components/Stack";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useSetSearchInputAtom } from "./search/searchInputAtom";
import type { GoogleMapMouseEvent } from "./types";
import { useMapController } from "./useMapController";
import { useMarkerController } from "./useMarkerController";

export const MapController = () => {
    const { camera, handleCameraChange } = useMapController();
    const { pin, movePin } = useMarkerController();
    const setSearchInput = useSetSearchInputAtom();
    const {
        cmsData: {
            location: { isThisTheCorrectLocationOfYourProperty },
        },
    } = useStaticDataAtomValue();

    const handlePinDrop = (e: GoogleMapMouseEvent) => {
        setSearchInput("");
        movePin(e.latLng.toJSON());
    };

    return (
        <VStack gap="12">
            <Box
                width="100%"
                aspectRatio="1"
                borderRadius="8"
                overflow="hidden"
                qM={{ aspectRatio: "2" }}
                data-element-name="location-google-map"
            >
                <GoogleMaps
                    style={{
                        width: "100%",
                        borderRadius: "8px",
                    }}
                    gestureHandling="greedy"
                    reuseMaps
                    onClick={(e) => movePin(e.detail.latLng)}
                    onCameraChanged={handleCameraChange}
                    disableDefaultUI={true}
                    {...camera}
                >
                    <Marker position={pin} draggable onDragEnd={handlePinDrop} />
                </GoogleMaps>
            </Box>
            <Typography variant="body-s" textColor="base.subtle">
                {isThisTheCorrectLocationOfYourProperty}
            </Typography>
        </VStack>
    );
};
